import type { GQL } from '@aline/graphql';
import type { BaseElement } from 'slate';

import type { UUID } from '../../../types/type-helpers';
import type { AlineText, SuggestedEdit } from '../../internal';

export type CannedFieldType = 'CANNED';
export const cannedFieldType: CannedFieldType = 'CANNED';

export interface CannedFieldElement extends BaseElement {
  cannedFieldId: UUID;
  children: AlineText[];
  suggestedEdits: SuggestedEdit[];
  type: CannedFieldType;
  variant: GQL.CannedFieldVariant;
  /**
   * Addresses this one occurrence, the way a PDF canned widget's own nodeId
   * does. Every occurrence of a field carries the same `cannedFieldId`, so
   * this is the only handle that names a single placement. No DB row stores
   * it, and nodes written before placements carried an id have none.
   */
  placementNodeId?: UUID | undefined;
}

export type CannedFieldProps = Omit<CannedFieldElement, 'children'>;
